import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

if (environment.production) {
  enableProdMode();
}

const firebaseApp = getApps().length ? getApp() : initializeApp(environment.firebaseConfig);

isSupported().then(supported => {
  if (supported) {
    getAnalytics(firebaseApp);
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
